export default __webpack_public_path__ + "static/media/adinkra_beredum.b0fe9998.png";